module.exports = __webpack_public_path__ + "static/media/31JFA1.f40ee0e8.jpg";